<template>
	<view>
		<!-- 图片 -->
		<div class="picture">
			<img class="picture_img" src="../../static/taocan.png" alt="">
		</div>

		<!-- 标题/价格 -->
		<div class="caption">
			<div class="price">
				<div class="price_style">
					<div class="price_txt1">￥1219.00</div>
					<div class="price_txt2">起</div>
					<div class="price_txt3">￥2330</div>
				</div>
				<div>
					<div class="price_txt4">共32项检查项</div>
				</div>
			</div>

			<div class="title">
				<div>
					<span class="title_txt">【双十一限定】乐享健康体检套餐(男)</span>
				</div>
				<div class="title_style">
					<img class="title_img" src="../../static/fenxiang.png" alt="">
					<span class="title_txt1">分享有礼</span>
				</div>
			</div>
		</div>

		<!-- 服务 -->
		<div class="service">
			<div>
				<span class="service_txt1">服务</span>
			</div>
			<div class="service">
				<img class="service_img" src="../../static/duigou.png" alt="">
				<span class="service_txt1">一键改约</span>
			</div>
			<div class="service">
				<img class="service_img" src="../../static/duigou.png" alt="">
				<span class="service_txt1">未使用可退</span>
			</div>
			<div class="service">
				<img class="service_img" src="../../static/duigou.png" alt="">
				<span class="service_txt1">专业医护</span>
			</div>
			<div class="service">
				<img class="service_img" src="../../static/duigou.png" alt="">
				<span class="service_txt1">贴心服务</span>
			</div>
		</div>

		<!-- 套餐简介 -->
		<div class="introduction">
			<div class="introduction_style">
				<img class="introduction_img" src="../../static/dingwi.png" alt="">
				<div class="introduction_txt">套餐简介</div>
			</div>
			<div>适用分院</div>
			<div>包含项目</div>
		</div>

		<!-- 使用人群 -->
		<div class="use">
			<div class="use_style1">
				<span class="use_txt">使用人群</span>
			</div>
			<div class="use_style">
				<div class="use_style2">
					<img class="use_img" src="../../static/1.png" alt="">
					<span class="use_txt">中青年</span>
				</div>
				<div class="use_style2">
					<img class="use_img" src="../../static/2.png" alt="">
					<span class="use_txt">中老年</span>
				</div>
				<div class="use_style2">
					<img class="use_img" src="../../static/3.png" alt="">
					<span class="use_txt">防癌筛查</span>
				</div>
			</div>
		</div>

		<!-- 套餐特点 -->
		<div class="characteristic">
			<span class="characteristic_txt">套餐特点</span>
		</div>

		<!-- 购物车 -->
		<!-- <div class="shopping">
			<div class="shopping_left">
				<img class="shopping_img" src="../../static/gouwuche.png" alt="">
				<span class="shopping_txt">购物车</span>
			</div >
				<div class="shopping_right">
					<div class="shopping_right_txt"><span>加入购物车</span></div>
					<div class="shopping_right_txt1"><span>立即预约</span></div>
				</div>
		</div> -->

		<uni-goods-nav class="shopping" :fill="true" :options="Options" :button-group="btnGroup"
			@buttonClick="doBtnGroupClick" />
	</view>
</template>

<script>
	export default {
		data() {
			return {
				Options: [{
					icon: 'cart',
					text: '购物车',
				}, ],
				btnGroup: [{
						text: '加入购物车',
						backgroundColor: '#fab64c',
						color: '#fff'
					},
					{
						text: '立即预约',
						backgroundColor: '#ff834c',
						color: '#fff'
					},
				]
			}
		},
		methods: {
			doBtnGroupClick({index}){
				if(index===1){
					uni.navigateTo({
						url: '/pages/physicalAppointment/physicalAppointment'
					})
				}
			}
		}
	}
</script>

<style lang="scss">
	.picture {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.picture_img {
		width: 100%;
	}

	.price {
		display: flex;
		align-items: flex-end;
		justify-content: space-between;
	}

	.price_style {
		display: flex;
		align-items: flex-end;
	}

	.price_txt1 {
		font-size: 22px;
		font-weight: 800;
		color: #fe5602;
	}

	.price_txt2 {
		font-size: 12px;
		font-weight: 800;
		color: #fe5602;
	}

	.price_txt3 {
		font-size: 12px;
		color: #ccc;
		text-decoration: line-through;
	}

	.price_txt4 {
		font-size: 14px;
		color: #838383;
		font-weight: 400;

	}

	.title {
		margin-top: 10px;
		display: flex;
		justify-content: space-between;
	}

	.title_txt {
		font-size: 18px;
		font-weight: 600;
	}

	.title_style {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.title_img {
		width: 20px;
		height: 20px;
	}

	.title_txt1 {
		font-size: 12px;
		color: #838383;
		font-weight: 400;
	}

	.service {
		display: flex;
		justify-content: space-around;
		align-items: center;
	}

	.service_txt1 {
		font-size: 14px;
		font-weight: 600;
	}

	.service_img {
		width: 15px;
		height: 15px;
		margin-right: 2px;
	}

	.introduction {
		height: 37px;
		border-bottom: 2px solid #f0f0f0;
		margin-top: 10px;
		display: flex;
		align-items: center;
		justify-content: space-around;
	}

	.introduction_style {
		display: flex;
	}

	.introduction_img {
		width: 20px;
		height: 20px;
		margin-right: 2px;
	}

	.introduction_txt {
		font-size: 15px;
		color: #ff5604;
	}

	.use {
		height: 200px;
		border-bottom: 2px solid #f0f0f0;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		margin-top: 20px;
	}

	.use_style1 {
		margin-bottom: 20px;
	}

	.use_txt {
		font-size: 16px;
		color: #838383;
	}

	.use_style {
		display: flex;
		flex-direction: row;
		align-items: center;
		flex-wrap: nowrap;
	}

	.use_style2 {
		display: flex;
		flex-direction: column;
		align-items: center;
		margin-right: 20px;
	}

	.use_img {
		width: 90px;
		height: 90px;
	}

	.characteristic {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.characteristic_txt {
		font-size: 16px;
		color: #838383;
	}

	.shopping {
		// width: 100%;
		// position: absolute;
		// display: flex;
		// justify-content: space-between;
		position: fixed;
		left: 0;
		right: 0;
		bottom: 0;
	}

	// .shopping_left {
	// 	display: flex;
	// 	flex-direction: column;

	// }

	// .shopping_img {
	// 	width: 25px;
	// 	height: 25px;
	// }

	// .shopping_txt {
	// 	font-size: 12px;
	// 	color: #838383;
	// }

	// .shopping_right{
	// 	display: flex;
	// }
	// .shopping_right_txt {
	// 	width: 204rpx;
	// 	height: 80rpx;
	// 	color: #fff;
	// 	margin-right: 10px;
	// 	display: flex;
	// 	align-items: center;
	// 	justify-content: center;
	// 	border-radius: 20px 20px 20px 20px;
	// 	background-color: #fab64c;
	// }

	// .shopping_right_txt1 {
	// 	width: 204rpx;
	// 	height: 80rpx;
	// 	color: #fff;
	// 	display: flex;
	// 	align-items: center;
	// 	justify-content: center;
	// 	border-radius: 20px 20px 20px 20px;
	// 	background-color: #ff834c;
	// }
</style>
